import { useState } from 'react';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9u4gun8l97n3eas3h50';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value || '';
    if (honeypot.trim()) {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      const response = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (response.ok && (!parsed || parsed.code === 'OK')) {
        setStatus('success');
        setMessage('感谢订阅！我们会定期发送精选护肤知识到你的邮箱。');
        setEmail('');
      } else if (serverMsg.includes('spam')) {
        setStatus('error');
        setMessage('提交失败，请稍后再试');
      } else {
        setStatus('error');
        setMessage(serverMsg || '订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-accent-100/60">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-200 text-accent-700 mb-6">
          <i className="ri-mail-send-line text-xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          订阅护肤周报
        </h2>
        <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto leading-relaxed">
          每周一封邮件，精选最值得看的护肤知识、成分解析和素颜技巧，不错过任何一次变美的机会。
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-readdy-form="">
          <input
            type="text"
            name="phone_alt"
            className="spam-guard"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap"
          >
            {status === 'loading' ? '订阅中...' : '免费订阅'}
          </button>
        </form>
        {message && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-700' : 'text-red-500'}`}>
            {message}
          </p>
        )}
        <p className="text-xs text-foreground-400 mt-4">
          我们尊重你的隐私，绝不发送垃圾邮件，可随时退订
        </p>
      </div>
    </section>
  );
}